module.exports = __webpack_public_path__ + "static/media/SDFSA_7-682w.85fae87b.jpg";